<template>
  <loader-wrapper :loading="loading" style="position: relative">
    <yandex-map
      :settings="settings"
      :coords="center"
      :zoom.sync="zoom"
      :controls="controls"
      :cluster-options="clusterOptions"
      ymap-class="ymap-desktop"
      @map-was-initialized="mapLoaded"
    >
      <ymap-marker
        v-for="car in carsList"
        :key="getID(car.id)"
        :marker-id="getID(car.id)"
        :coords="car.coords"
        :icon="{ ...markerIcon, content: car.num }"
        cluster-name="cluster"
      />
    </yandex-map>
  </loader-wrapper>
</template>

<script>
import {
  MAP_CENTER,
  balloonLayout,
  clusterOptions,
  markerIconDesktop,
  multiRouteOptions,
  ymapSettings,
} from './constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'DriversYMap',
  components: { LoaderWrapper },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    radio: {
      type: String,
      default: '',
    },
    cars: {
      type: Array,
      default: () => [],
    },
    coords: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      zoom: 8,
      controls: ['zoomControl', 'fullscreenControl'],
      center: MAP_CENTER,
      settings: ymapSettings,
      markerIcon: markerIconDesktop,
      clusterOptions,
      map: null,
      loading: false,
    }
  },
  computed: {
    carsList() {
      let arr = []

      this.cars.map(car => {
        if (this.coords[car.id]) {
          const { lat, lng } = this.coords[car.id]

          arr.push({ ...car, coords: [lat, lng] })
        }
      })

      return arr
    },
  },
  watch: {
    cars() {
      this.setCenter()
    },
    bid() {
      if (this.map) {
        this.map.geoObjects.removeAll()
      }
      this.setRoute()
    },
  },
  methods: {
    getID(id) {
      return id + this.radio
    },
    mapLoaded(e) {
      e.options.set('suppressMapOpenBlock', true)
      this.map = e
      this.setCenter()
    },
    setCenter() {
      if (this.carsList.length && this.carsList[0].coords) {
        this.center = this.carsList[0].coords
      }
    },
    setRoute() {
      this.loading = true
      const {
        load_coords_lat,
        load_coords_lon,
        unload_coords_lat,
        unload_coords_lon,
      } = this.bid

      if (load_coords_lat && unload_coords_lat && window.ymaps && this.map) {
        this.points = [
          [load_coords_lat, load_coords_lon],
          [unload_coords_lat, unload_coords_lon],
        ]
        const balloon = window.ymaps.templateLayoutFactory.createClass(
          ...balloonLayout,
        )
        const opt = multiRouteOptions(this.points, balloon)
        const multiRoute = new window.ymaps.multiRouter.MultiRoute(...opt)

        this.map.geoObjects.add(multiRoute)
        multiRoute.events.once('update', this.stopLoading)
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      this.loading = false
    },
  },
}
</script>

<style lang="sass">
.ymap-desktop
  height: 80vh
</style>
